import React from 'react';
import { Link, useLocation } from 'react-router-dom';

function NavBar() {
    const location = useLocation();
    
    // If the user is on the login page, do not render the navbar
    if (location.pathname === '/login') {
        return null;
    }

    return (

<nav class="navbar navbar-expand-lg navbar-light bg-light">
 
 
  <div class="collapse navbar-collapse" id="navbarNavDropdown">
    <ul class="navbar-nav">


               {/* <li class="nav-item active"><Link to="/home">Home</Link></li> */}
                 <li class="nav-item"><Link to="/dashboard">Dashboard</Link></li>
                 <li class="nav-item"><Link to="/reportservices">Reporting Services</Link></li>
                 <li class="nav-item"><Link to="/voicecommand">Voice Command Analysis</Link></li>
                 {/* <li class="nav-item"><Link to="/chatbot">Chat Bot</Link></li> */}
                 <li class="nav-item"><Link to="/chatbotjson">Chat Bot</Link></li>
                 <li class="nav-item"><Link to="/analysis">Analysis</Link></li>
                 <li class="nav-item"><Link to="/login">Log Out</Link></li>      
     
    </ul>
  </div>
</nav>        
    );
}

export default NavBar;
